import React, { useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import useUserStore from "../../../../utils/storeApp";
import CallAPI from "../../../../services/apiCalls";
import $ from "jquery";
import { stateCodeArray } from "../../../../services/fakeDB/ListUser";
import SpecialtyDropdown from "../../../shared/SpecialtyDropdown";
import Npi from "../../../shared/NPI/NPI";
/*import NoReply from "../../../emails/NoReply";*/
import { usePortalAuthentication } from "../../../../services/authorizationService";

const o = {
  Addressess: {
    FirstLine: "",
    SecondLine: "",
    City: "",
    State: "",
    PostalCode: "",
    Country: "USA",
    Phone: "",
    PhoneExt: "",
    Fax: "",
    FaxExt: "",
  },
  Administrator: false,
  AllowDMEAccess: false,
  AllowENSAccess: false,
  AllowFormsAccess: false,
  AllowPriorAuthAccess: false,
  ClaimsAttachmentPayer: false,
  ClaimsAttachmentProvider: false,
  ClaimsAttachmentStaff: false,
  ContactEmail: "",
  CreateUsers: false,
  Credential: "",
  ParentVendorId: "",
  UserType: null,
  DME_Payer: false,
  DME_Provider: false,
  DME_Staff: false,
  DME_Supplier: false,
  DirectEmail: false,
  DomainName: "",
  FirstName: "",
  FullName: "",
  HasAddresses: false,
  HasSpecialties: false,
  IDs: [],
  Id: null,
  IsLockedByAdmin: false,
  IssueInvites: false,
  LastLoginTime: null,
  LastName: "",
  LockoutEnabled: false,
  LockoutEndDate: null,
  NPI: null,
  PreAuthProvider: false,
  PreAuthReviewer: false,
  PreAuthStaff: false,
  PreAuthSupervisor: false,
  RegistrationStatus: 5,
  RequireIdVerification: false,
  Specialties: [null],
  Status: "Completed",
  TFAEmail: "",
  TFAOn: false,
  TFAPhone: null,
  TrustedAgent: false,
  TwoFactorEnabled: true,
  UserDirectEmailId: null,
  UserName: "",
  UserNameDisplay: "",
  UserTypeString: "",
  VendorEmailForwardingType: null,
  VendorEmailForwardingTypeString: "",
  NoReply: false,
};

function formatPhoneNumber(value) {
  if (!value) return value;
  const phoneNumber = value.replace(/[^\d]/g, "");
  const phoneNumberLength = phoneNumber.length;
  if (phoneNumberLength < 4) return phoneNumber;
  if (phoneNumberLength < 7) {
    return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(3)}`;
  }
  return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(
    3,
    6,
  )}-${phoneNumber.slice(6, 10)}`;
}
const FormUserContact = () => {
  const navigate = useNavigate();
  const { logout } = usePortalAuthentication();
  const { userToken, sharedObject, SetSharedObject, userRole, userSession } =
    useUserStore((state) => ({
      userToken: state.userToken,
      sharedObject: state.sharedObject,
      SetSharedObject: state.SetSharedObject,
      userRole: state.userRole,
      userSession: state.userSession,
    }));
  const [answers, setAnswers] = useState(o);
  const [processing, SetProcessing] = useState(false);
  const [userObj, SetUserObj] = useState({});
  const [errCreateMsg, SetErrCreateMsg] = useState(false);
  const [errMsg, SetErrMsg] = useState(false);
  const [errEmail, SetErrEmail] = useState(false);
  const [frmSubmFlag, SetSubmitFlag] = useState(false);
  const [userEditDetails, SetuserEditDetails] = useState({
    specialties: [null],
  });
  const [specialtiesFlag, SetspecialtiesFlag] = useState(false);
  const setAnswer = async (questionId, answer, chck) => {
    if (chck) {
      let obj = { ...answers };
      let add = answers.Addressess;
      add[questionId] = answer;
      obj.Addressess = add;
      await setAnswers(obj);
    } else {
      await setAnswers({ ...answers, [questionId]: answer });
    }
  };
  const getUserDetailsById = async (id) => {
    SetProcessing(true);
    let call = "/admin/GetPreRegUserById?userId=" + id;
    const res = await CallAPI(call, false, "get", userToken);
    await SetSharedObject("ResponseCode", res.code);
    if (res.status === "SUCCESS") {
      let det = res?.data?.data;
      let ob = {
        ...answers,
        NamePrefix: det.namePrefix,
        FirstName: det.firstName,
        LastName: det.lastName,
        UserName: det.userName,
        DomainName: det.domainName,
        ParentOrganizationId: det.org_id,
        ParentVendorId: det.vendorId,
        Credential: det.credential,
        RequireIdVerification: det.requireIdVerification,
      };
      await setAnswers(ob);
      SetUserObj(det);
      SetProcessing(false);
    } else if (res.status === "SERVERERROR") {
      SetErrMsg(`<div>${res.data.message}</div>`);
      SetErrCreateMsg(true);
      SetProcessing(false);
    }
  };
  useEffect(() => {
    PreRegistration();
    SetspecialtiesFlag(false);
    return () => {
      setAnswers(o);
      SetspecialtiesFlag(false);
      SetErrEmail(false);
    };
  }, []);
  const PreRegistration = async () => {
    getUserDetailsById(userSession.sesuser_id);
  };
  const CheckSpecialty = () => {
    let flag =
      isEmpty(sharedObject.specialties.Code) &&
      (!isEmpty(sharedObject.specialties.Type) ||
        !isEmpty(sharedObject.specialties.Classification));
    return flag;
  };
  function isEmpty(value) {
    let x =
      value == null || (typeof value === "string" && value.trim().length === 0);
    return x;
  }

  const AddUserRegistration = async () => {
    SetSubmitFlag(true);
    SetErrCreateMsg(false);
    SetspecialtiesFlag(false);
    SetErrEmail(false);
    if (!answers.FirstName === "") {
      document.getElementById("FirstName").scrollIntoView();
      document.getElementById("FirstName").focus();
      return;
    } else if (!answers.LastName === "") {
      document.getElementById("LastName").scrollIntoView();
      document.getElementById("LastName").focus();
      return;
    } else if (answers.Addressess.FirstLine === "") {
      document.getElementById("FirstLine").scrollIntoView();
      document.getElementById("FirstLine").focus();
      return;
    } else if (answers.Addressess.City === "") {
      document.getElementById("City").scrollIntoView();
      document.getElementById("City").focus();
      return;
    } else if (answers.Addressess.State === "") {
      document.getElementById("State").scrollIntoView();
      document.getElementById("State").focus();
      return;
    } else if (answers.Addressess.PostalCode === "") {
      document.getElementById("PostalCode").scrollIntoView();
      document.getElementById("PostalCode").focus();
      return;
    } else if (!isEmpty(sharedObject.specialties) && CheckSpecialty()) {
      SetspecialtiesFlag(true);
      return;
    } else if (
      (userObj.includeDirectEmail && answers.ContactEmail === "") ||
      (answers.ContactEmail !== "" &&
        (containsSpacesOrSpecialChars(answers.ContactEmail) ||
          answers.ContactEmail.length < 4))
    ) {
      document.getElementById("ContactEmail").scrollIntoView();
      document.getElementById("ContactEmail").focus();
      SetErrEmail(true);
      return;
    }
    if (answers.FirstName.length > 20) {
      document.getElementById("FirstName").scrollIntoView();
      document.getElementById("FirstName").focus();
      return;
    }
    answers.NamePrefix = isEmpty(answers.NamePrefix)
      ? null
      : parseInt(answers.NamePrefix);
    answers.Addressess.Phone =
      answers.Addressess.Phone.replace(/[^0-9]/g, "").substring(0, 10) +
      answers.Addressess.PhoneExt;
    answers.Addressess.Fax = answers.Addressess.Fax
      ? answers.Addressess.Fax.replace(/[^0-9]/g, "").substring(0, 10)
      : "" + answers.Addressess.FaxExt;
    if (validatePhoneNumber(answers.Addressess.Phone, false)) {
      document.getElementById("Phone").scrollIntoView();
      document.getElementById("Phone").focus();
      return;
    }
    if (validatePhoneNumber(answers.Addressess.Fax, true)) {
      document.getElementById("Fax").scrollIntoView();
      document.getElementById("Fax").focus();
      return;
    }
    answers.Addressess.PostalCode = answers.Addressess.PostalCode.replace(
      /[^0-9]/g,
      "",
    ).substring(0, 9);
    if (validateZip(answers.Addressess.PostalCode)) {
      document.getElementById("PostalCode").scrollIntoView();
      document.getElementById("PostalCode").focus();
      return;
    }
    answers.Addresses = [answers.Addressess];
    SetProcessing(true);
    answers.FullName = answers.FirstName + answers.LastName;
    let dEmail = answers.ContactEmail ? answers.ContactEmail : null;
    let sCode = null;
    if (answers.specializationCode) {
      sCode = answers.specializationCode;
    } else {
      answers.Specialties = [];
    }
    let call =
      "/admin/RegisterUser?directEmail=" +
      dEmail +
      "&specializationCode=" +
      sCode +
      "&noReply=" +
      answers.NoReply;
    const res = await CallAPI(call, answers, "post", userToken);
    await SetSharedObject("ResponseCode", res.code);
    if (res.status === "SUCCESS") {
      SetProcessing(false);
      if (userObj.requireIdVerification) {
        navigate("/experian-sso");
      } else {
        navigate("/success-pre-registration");
      }
    } else if (res.status === "SERVERERROR" || res.status === "ECONNABORTED") {
      let msg = res.data;
      let str = "";
      if (typeof msg === "string") {
        str = msg;
      } else {
        str = "<div>";
        str +=
          "We have encountered an system error and it is not responding.Please try again and contact support if the problem persists.";
        // for (let el of msg) {
        //   str += `${el}`;
        // }
        str += "</div>";
      }

      SetErrMsg(str);
      SetErrCreateMsg(true);
      SetProcessing(false);
    }
    // success navigate to={"/registration-success"}
  };
  const SpecialFormFields = async (val) => {
    await setAnswers({
      ...answers,
      Specialties: [val],
      specializationCode: val.Code,
    });
  };

  const modalRef = useRef(null);
  function Confirm() {
    $("#ConfirmModal").modal("show");
    setTimeout(() => {
      if (modalRef.current) {
        modalRef.current.focus();
      }
    }, 500);
  }
  const containsSpacesOrSpecialChars = (str) => {
    let flag = /[^a-zA-Z0-9-_@.]/.test(str);
    return flag;
  };
  const validateZip = (str) => {
    let flag = false;
    if (str.length !== 5 && str.length !== 9) {
      flag = true;
    }
    return flag;
  };
  const validatePhoneNumber = (str, isFax) => {
    let flag = /[^0-9.]/.test(str);
    if (isFax === false && str.length < 10) {
      flag = true;
    } else if (isFax === true && str.length > 0 && str.length < 10) {
      flag = true;
    }
    return flag;
  };
  const userEdit = (obj) => {
    setAnswers({
      ...answers,
      OrganizationName: obj.Name,
      Addressess: obj.Addresses,
      NPI: obj.NPI,
    });
  };

  const [loadingText, setLoadingText] = useState("Loading...");
  useEffect(() => {
    let timer;
    if (processing) {
      timer = setTimeout(() => {
        setLoadingText("Working on it...");
      }, 10000);
    } else {
      setLoadingText("Loading...");
    }

    return () => clearTimeout(timer);
  }, [processing]);

  const CloseModal = () => {
    if (document.activeElement instanceof HTMLElement) {
      document.activeElement.blur();
    }

    $("#ConfirmModal").modal("hide");
  };

  return (
    <div className="FormUserContact">
      <div className="sp-pad">
        <form
          className="form-container"
          onSubmit={(e) => {
            e.preventDefault();
            AddUserRegistration();
          }}
        >
          <label htmlFor="">Provider</label>
          <Npi userEdit={userEdit} />
          <div className="field-wrapper spacer-inline spacer-margin5 v-top">
            {/*Prefix*/}
            <label htmlFor="prefix">Prefix</label>
            <select
              className="form-control field-ext"
              name="prefix"
              onChange={(el) => setAnswer("NamePrefix", el.target.value)}
              value={answers.NamePrefix}
            >
              <option value="">Select</option>
              <option value="5">Prof</option>
              <option value="4">Dr</option>
              <option value="1">Mr</option>
              <option value="3">Mrs</option>
              <option value="2">Miss</option>
            </select>
          </div>
          {/*First Name*/}
          <div className="field-wrapper w-lg6 spacer-inline v-top">
            <label htmlFor="FirstName">First Name</label>
            <input
              type="text"
              className="form-control"
              id="FirstName"
              name="FirstName"
              autoComplete="given-name"
              required
              aria-invalid={answers.FirstName === "" && frmSubmFlag}
              aria-describedby={
                answers.FirstName === "" && frmSubmFlag
                  ? "FirstNameError"
                  : undefined
              }
              onChange={(el) => setAnswer("FirstName", el.target.value)}
              value={answers.FirstName}
            />
            {answers.FirstName === "" && frmSubmFlag ? (
              <div
                className="alert alert-danger"
                id="FirstNameError"
                role="alert"
                aria-live="assertive"
              >
                First name is required.
              </div>
            ) : null}
            {answers.FirstName.length > 20 && frmSubmFlag ? (
              <div className="alert alert-danger">
                Cannot be more than 20 characters
              </div>
            ) : null}
          </div>
          {/*Last Name*/}
          <div className="field-wrapper field-box2">
            <label htmlFor="LastName">Last Name</label>
            <input
              type="text"
              className="form-control"
              id="LastName"
              name="LastName"
              autoComplete="family-name"
              required
              aria-invalid={answers.LastName === "" && frmSubmFlag}
              aria-describedby={
                answers.LastName === "" && frmSubmFlag
                  ? "LastNameError"
                  : undefined
              }
              onChange={(el) => setAnswer("LastName", el.target.value)}
              value={answers.LastName}
            />
            {answers.LastName === "" && frmSubmFlag ? (
              <div
                className="alert alert-danger"
                id="LastNameError"
                role="alert"
              >
                Last name is required.
              </div>
            ) : null}
          </div>
          {/*Credential optional*/}
          <div className="field-wrapper field-box3">
            <label htmlFor="credential">Credential</label>
            <input
              className="form-control"
              name="credential"
              autoComplete="off"
              placeholder="Optional"
              onChange={(el) => setAnswer("Credential", el.target.value)}
              value={answers.Credential}
            />
          </div>
          {/*Address 1*/}
          <div className="field-wrapper field-box2">
            <label htmlFor="FirstLine">Address 1</label>
            <input
              className="form-control"
              name="address1"
              id="FirstLine"
              autoComplete="address-line1"
              required
              aria-invalid={answers.Addressess.FirstLine === "" && frmSubmFlag}
              aria-describedby={
                answers.Addressess.FirstLine === "" && frmSubmFlag
                  ? "FirstLineError"
                  : undefined
              }
              onChange={(el) => setAnswer("FirstLine", el.target.value, true)}
              value={answers.Addressess.FirstLine}
            />
            {answers.Addressess.FirstLine === "" && frmSubmFlag ? (
              <div
                className="alert alert-danger"
                id="FirstLineError"
                role="alert"
                aria-live="polite"
              >
                Address is required.
              </div>
            ) : null}
          </div>
          {/*Address 2 optional*/}
          <div className="field-wrapper field-box3">
            <label htmlFor="LastLine">Address 2</label>
            <input
              className="form-control"
              name="address2"
              id="LastLine"
              autoComplete="address-line2"
              placeholder="Optional"
              onChange={(el) => setAnswer("SecondLine", el.target.value, true)}
              value={answers.Addressess.SecondLine}
            />
          </div>
          {/*City*/}
          <div className="field-wrapper">
            <div className="field-box2 spacer-inline v-top">
              <label htmlFor="city">City</label>
              <input
                className="form-control"
                name="city"
                id="City"
                autoComplete="address-level2"
                required
                aria-invalid={answers.Addressess.City === "" && frmSubmFlag}
                aria-describedby={
                  answers.Addressess.City === "" && frmSubmFlag
                    ? "CityError"
                    : undefined
                }
                onChange={(el) => setAnswer("City", el.target.value, true)}
                value={answers.Addressess.City}
              />
              {answers.Addressess.City === "" && frmSubmFlag ? (
                <div className="alert alert-danger" id="CityError" role="alert">
                  City is required.
                </div>
              ) : null}
            </div>
            {/*State*/}
            <div className="field-ext spacer-inline spacer-margin5 v-top">
              <label htmlFor="user-contact-state">State</label>
              <select
                className="form-control"
                name="state"
                id="user-contact-state"
                required
                aria-invalid={answers.Addressess.State === "" && frmSubmFlag}
                aria-describedby={
                  answers.Addressess.State === "" && frmSubmFlag
                    ? "StateError"
                    : undefined
                }
                onChange={(el) => setAnswer("State", el.target.value, true)}
                value={answers.Addressess.State}
              >
                <option value={""}>Select</option>
                {stateCodeArray.map((el) => (
                  <option key={el} value={el}>
                    {el}
                  </option>
                ))}
              </select>
              {answers.Addressess.State === "" && frmSubmFlag ? (
                <div
                  className="alert alert-danger"
                  id="StateError"
                  role="alert"
                >
                  State is required.
                </div>
              ) : null}
            </div>
            {/*Zip Code*/}
            <div className="field-ext spacer-inline v-top">
              <label htmlFor="zip">Zip</label>
              <input
                className="form-control"
                name="zip"
                id="PostalCode"
                autoComplete="postal-code"
                required
                aria-invalid={
                  answers.Addressess.PostalCode === "" && frmSubmFlag
                }
                aria-describedby={
                  answers.Addressess.PostalCode === "" && frmSubmFlag
                    ? "PostalCodeError"
                    : undefined
                }
                value={answers.Addressess.PostalCode}
                maxLength={5}
                onChange={(el) => {
                  const onlyNums = el.target.value.replace(/[^0-9]/g, "");
                  setAnswer("PostalCode", onlyNums, true);
                }}
              />
              {answers.Addressess.PostalCode === "" && frmSubmFlag ? (
                <div
                  className="alert alert-danger"
                  id="PostalCodeError"
                  role="alert"
                >
                  Zip is required.
                </div>
              ) : null}
              {answers.Addressess.PostalCode.replace(/[^0-9]/g, "").substring(
                0,
                9,
              ).length !== 9 &&
              frmSubmFlag &&
              answers.Addressess.PostalCode.replace(/[^0-9]/g, "").substring(
                0,
                9,
              ).length !== 5 &&
              frmSubmFlag &&
              answers.Addressess.PostalCode.replace(/[^0-9]/g, "").substring(
                0,
                9,
              ).length > 0 ? (
                <div className="alert alert-danger">Invalid Zip Code.</div>
              ) : null}
            </div>
          </div>
          {/*Phone*/}
          <div className="field-wrapper ">
            <div className="field-box2 spacer-inline v-top">
              <label htmlFor="Phone">Phone</label>
              <input
                className="form-control"
                id="Phone"
                name="Phone"
                autoComplete="tel"
                required
                aria-invalid={answers.Addressess.Phone === "" && frmSubmFlag}
                aria-describedby={
                  answers.Addressess.Phone === "" && frmSubmFlag
                    ? "PhoneError"
                    : undefined
                }
                onChange={(el) => setAnswer("Phone", el.target.value, true)}
                value={formatPhoneNumber(answers.Addressess.Phone)}
              />
              {answers.Addressess.Phone === "" && frmSubmFlag ? (
                <div
                  className="alert alert-danger"
                  id="PhoneError"
                  role="alert"
                >
                  Phone number is required.
                </div>
              ) : null}
              {answers.Addressess.Phone.replace(/[^0-9]/g, "").substring(0, 10)
                .length < 10 &&
              frmSubmFlag &&
              answers.Addressess.Phone.replace(/[^0-9]/g, "").substring(0, 10)
                .length > 0 &&
              frmSubmFlag ? (
                <div className="alert alert-danger">Invalid Phone Number.</div>
              ) : null}
            </div>

            <div className="field-box3">
              <label htmlFor="OrgName">Ext</label>
              <input
                className="form-control"
                name="PhoneExt"
                autoComplete="tel-extension"
                maxLength={6}
                value={answers.Addressess.PhoneExt}
                onChange={(el) => {
                  const onlyNums = el.target.value.replace(/[^0-9]/g, "");
                  setAnswer("PhoneExt", onlyNums, true);
                }}
              />
            </div>
          </div>
          {/*Fax*/}
          <div className="field-wrapper">
            <div className="field-box2 spacer-inline v-top">
              <label htmlFor="OrgName">Fax</label>
              <input
                className="form-control"
                name="FaxNumber"
                id="Fax"
                autoComplete="off"
                placeholder="Optional"
                onChange={(el) => setAnswer("Fax", el.target.value, true)}
                value={formatPhoneNumber(answers.Addressess.Fax)}
              />

              {answers.Addressess.Fax.replace(/[^0-9]/g, "").substring(0, 10)
                .length < 10 &&
              answers.Addressess.Fax.replace(/[^0-9]/g, "").substring(0, 10)
                .length > 0 &&
              frmSubmFlag ? (
                <div className="alert alert-danger">Invalid Fax Number.</div>
              ) : null}
            </div>
            <div className="field-box3">
              <label htmlFor="FaxExt">Ext</label>
              <input
                className="form-control"
                name="FaxExt"
                autoComplete="off"
                maxLength={6}
                value={answers.Addressess.FaxExt}
                disabled={
                  answers.Addressess.Fax.replace(/[^0-9]/g, "").length === 0
                }
                onChange={(el) => {
                  const onlyNums = el.target.value.replace(/[^0-9]/g, "");
                  setAnswer("FaxExt", onlyNums, true);
                }}
              />
            </div>
          </div>
          {userObj?.includeDirectEmail ? (
            <>
              <h6
                className="field-wrapper title-divider sp-pad9"
                id="directEmailTitle"
              >
                Direct Email
              </h6>
              <div className="field-wrapper">
                <label htmlFor="DirectEmail">Desired Email Name</label>
                <div className="input-group mb-3">
                  <input
                    type="text"
                    className="form-control field-direct"
                    id="ContactEmail"
                    autoComplete="off"
                    aria-invalid={answers.ContactEmail === "" && frmSubmFlag}
                    aria-describedby={
                      answers.ContactEmail === "" && frmSubmFlag
                        ? "ContactEmailError"
                        : undefined
                    }
                    onChange={(el) =>
                      setAnswer("ContactEmail", el.target.value)
                    }
                    value={answers.ContactEmail}
                  />
                  <div className="input-group-append">
                    <span
                      className="input-group-text field-direct-addon"
                      id="basic-addon2"
                    >
                      {"@"}
                      {answers.DomainName}
                    </span>
                  </div>
                </div>
              </div>
              {/*<div className="field-wrapper">
                <div className="NoReply spacer-inline">
                  <input
                    className="form-control spacer-margin5 sp-mx"
                    type="checkbox"
                    onChange={(el) => setAnswer("NoReply", el.target.checked)}
                    value={answers.NoReply}
                  />
                </div>
                <label className="v-top">Set as no-reply mailbox</label>
                <aside className="text-reg">
                  Check this box if this mailbox cannot reply to emails.
                </aside>
              </div>*/}
              {errEmail ? (
                <div
                  className="alert alert-danger"
                  id="ContactEmailError"
                  role="alert"
                  aria-live="assertive"
                  aria-atomic="true"
                >
                  Please enter a valid email name with more than 4 characters
                  long, no spaces, commas, or special characters.
                </div>
              ) : null}
            </>
          ) : null}
          {userRole !== "SYSTEMADMINISTRATOR" && (
            <>
              {/*Specialty */}
              <h6
                className="field-wrapper title-divider sp-pad9"
                id="specialtyTitle"
              >
                Specialty
              </h6>
              <div className="field-wrapper text-reg">
                This section is optional but we highly recommend you select
                these options to identify specific areas of focus in the
                organization.{" "}
                <strong className="or-clr">
                  If you select a type, then you must select both classification
                  and specialization.
                </strong>
              </div>
              <SpecialtyDropdown
                //codes={orgValues?.codes}
                SpecialFormFields={(el, val) => SpecialFormFields(el, val)}
                editObj={userEditDetails?.specialties}
              />
              {specialtiesFlag && frmSubmFlag ? (
                <div
                  className="alert alert-danger"
                  id="SpecialtyId"
                  role="alert"
                  aria-live="assertive"
                  aria-atomic="true"
                >
                  Specialization is required when you are selecting Type or
                  Classification.
                </div>
              ) : null}
              {errCreateMsg ? (
                <div
                  className={`alert alert-danger`}
                  dangerouslySetInnerHTML={{ __html: errMsg }}
                  role="alert"
                  aria-live="assertive"
                  aria-atomic="true"
                />
              ) : null}
            </>
          )}
          {/*Register Action*/}
          <div className="button-register-container ">
            <div className="spacer-inline">
              <button
                type="submit"
                className="btn btn-success"
                //onClick={AddUserRegistration}
              >
                Register
              </button>
              <button
                onClick={Confirm}
                type="button"
                className="btn btn-outline-secondary spacer-margin2"
              >
                Cancel
              </button>
            </div>
            {processing ? (
              <div
                className="loader-container"
                role="status"
                aria-live="polite"
                aria-atomic="true"
                aria-labelledby="loader-id"
              >
                <div className="spinner" aria-hidden="true"></div>
                <div className="loading-text" id="loader-id">
                  {loadingText}
                </div>
              </div>
            ) : null}
          </div>
        </form>
      </div>
      <div className="ConfirmModal">
        <div
          className="modal fade"
          id="ConfirmModal"
          tabIndex="-1"
          role="dialog"
          aria-modal="true"
          aria-labelledby="ConfirmModalTitle"
          aria-describedby="ConfirmModalDesc"
          data-backdrop="static"
          ref={modalRef}
        >
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h3 className="modal-title" id="ConfirmModalTitle">
                  Confirmation
                </h3>
                <button
                  type="button"
                  className="close"
                  onClick={CloseModal}
                  aria-label="Close"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div className="modal-body" id="ConfirmModalDesc">
                <div className="alert-warning-o">
                  <i
                    className="bi bi-exclamation-circle"
                    aria-hidden="true"
                  ></i>
                </div>

                <div className="message-wrapper">
                  Are you sure want to cancel your registration?
                </div>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-success"
                  onClick={(e) => {
                    CloseModal();
                    e.preventDefault();
                    logout();
                    // Optionally, return focus to the Cancel button or previous element
                  }}
                >
                  Confirm
                </button>
                <button
                  type="button"
                  className="btn btn-outline-secondary"
                  onClick={CloseModal}
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FormUserContact;
